import { memoize } from 'lodash/fp';
import { NumberFormatting } from '@mews-framework/globalization';

export const createCultureFormatRegex = memoize(
    ({ decimalSeparator, groupSeparator }: NumberFormatting) =>
        new RegExp(`^-?(([1-9]{1}[0-9]{0,2}(([${groupSeparator}\\s]?[0-9]{3})+)?)|0)(\\${decimalSeparator}[0-9]+)?$`)
);
